module.exports = __webpack_public_path__ + "img/Sign_in@2x.f59c9b3d.png";